import React from 'react'
import { Button, type ButtonProps } from '@mantine/core'

export type AppButtonProps = ButtonProps;

/**
 * Standard button with ember color and sm radius.
 * Default height: 36px (Mantine size="sm" equivalent)
 * Override with size prop if needed: size="xs" (24px), "sm" (36px), "md" (44px), "lg" (50px)
 */
export default function AppButton ({ size = 'sm', ...props }: AppButtonProps) {
  return <Button color="ember" radius="sm" size={size} {...props} />
}
